// Lane B9's screens, registered the way every lane registers its own (lane contract C-29, PLAN T-8, T-12) and hosted
// in MissionShell's content slot through lane B2's requisition detail:
//
//   #requisitions/R-####/closure[?designate=<application>]
//                                 the Disposition & handoff tab (registerRequisitionTab, which registers the route),
//                                 shown where `closeout.open` is callable; `designate` opens that application's
//                                 talent community designation
//   the archived banner           registerRequisitionBanner: *Archived {date}* with the snapshot's content hash on an
//                                 archived requisition, and Reopen where the server's `can` admits a reopen request
//                                 (lane B2's state change dialog, kind reopen)
//
// One import line in shell/views.ts loads this module.

import { createElement } from "react";
import { useRoute } from "@/router";
import { registerRequisitionBanner, registerRequisitionTab } from "@/views/requisition/RequisitionDetail";
import type { RequisitionBannerProps, RequisitionTabProps } from "@/views/requisition/slots";
import { ArchivedBanner, isArchived } from "./archive/ArchivedBanner";
import { ClosurePage } from "./Closure";
import { CLOSURE_TAB } from "./route";


/** The seat may ask to reopen this requisition: the requisition's own `can` and B2's state change door. */
function mayReopen(r: RequisitionBannerProps["r"], can: (tool: string) => boolean): boolean {
  return Boolean(r.can["request_reopen"] ?? r.can["reopen"]) && can("requisition.request_state_change");
}

function ClosureTab({ r }: RequisitionTabProps) {
  const designate = useRoute().params.get("designate");
  return createElement(ClosurePage, designate ? { key: r.id, rid: r.id, designate } : { key: r.id, rid: r.id });
}

function Archived({ r, can }: RequisitionBannerProps) {
  if (!isArchived(r)) return null;
  const archive = r.archive ?? null;
  const archivedAt = archive?.archived_at ?? r.archived_at ?? null;
  if (!archivedAt) return null;
  const canReopen = mayReopen(r, can);
  const onReopen = () => {
    window.location.hash = `#requisitions/${r.id}?action=state-change&kind=reopen`;
  };
  return createElement(ArchivedBanner, {
    requisitionId: r.id,
    archivedAt,
    contentHash: archive?.content_hash ?? "",
    canReopen,
    onReopen,
  });
}

registerRequisitionTab({
  key: CLOSURE_TAB.key,
  label: CLOSURE_TAB.label,
  lane: "B9",
  order: 60,
  component: ClosureTab,
  visible: (can) => can("closeout.open"),
});

registerRequisitionBanner({ key: "archived", lane: "B9", component: Archived });
